// extracted by mini-css-extract-plugin
module.exports = {"kickOff":"KickOffAuction_kickOff__2lhU6","kickOffBtn":"KickOffAuction_kickOffBtn__184Ii","explainer":"KickOffAuction_explainer__1ATlt"};